<template>
    <v-row>
        <v-col class="subtitle-1 form-subtitle">
            <span>{{ title }}</span>
            <v-btn
                v-if="showAdd"
                text
                color="primary"
                @click="$emit('click')"
            >
                <v-icon size="24" left>mdi-plus</v-icon>
                <span>{{ $t('Add') }}</span>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { $t } from "@/i18n";
export default {
    name: "CustomFormHeader",
    props: {
        title: {
            type: String,
            required: true
        },
        showAdd: {
            type: Boolean,
            default: false
        }
    },
};
</script>